/** Английские подписи LTMS-ролей (ключ — role.name с backend). */
export const LTMS_ROLE_LABELS_EN = {
  sa: {
    caption: 'Administrator',
    description: 'User and permission management + full access',
  },
  regspec: {
    caption: 'Registration specialist',
    description: 'Registration specialist',
  },
  reglead: {
    caption: 'Registration group lead',
    description: 'Registration group lead',
  },
  regcoord: {
    caption: 'Coordinator',
    description: 'Registration department coordinator',
  },
  gxp: {
    caption: 'GxP specialist',
    description: 'Good practice compliance specialist',
  },
  buh: {
    caption: 'Accountant',
    description: 'Accountant (Tax registry)',
  },
  pv: {
    caption: 'Pharmacovigilance officer',
    description: 'View Product List and Submissions',
  },
  med: {
    caption: 'Medical department staff',
    description: 'View SoH and Product List',
  },
  viewer: {
    caption: 'Viewer',
    description: 'Basic LTMS module access; registry view rights are assigned by an administrator',
  },
  globalteam: {
    caption: 'Global team',
    description: 'View medicinal product cards and dossier presentation folders',
  },
  common: {
    caption: 'Basic',
    description: 'Basic access rights',
  },
  locks: {
    caption: 'Set locks',
    description: 'Ability to apply locks',
  },
  locks_reset: {
    caption: 'Reset locks',
    description: 'Ability to reset locks',
  },
  upload_files: {
    caption: 'Upload files',
    description: 'Upload files to the server',
  },
  download_files: {
    caption: 'Download files',
    description: 'Download files from the server',
  },
  users_view: {
    caption: 'View users',
    description: 'View users',
  },
  users_edit: {
    caption: 'Edit users',
    description: 'Edit users',
  },
  account_updater: {
    caption: 'LTMS account actualization owner',
    description: 'Responsible for LTMS account actualization (assigned only to users with PRID)',
  },
  allow_ltms: {
    caption: 'View LTMS permissions',
    description: 'View LTMS user permissions',
  },
  catalog_view: {
    caption: 'Catalogs: view',
    description: 'View LTMS catalogs',
  },
  catalog_edit: {
    caption: 'Catalogs: edit',
    description: 'Edit LTMS catalogs',
  },
  medicines_view: {
    caption: 'Medicinal products catalog: view',
    description: 'View the medicinal products catalog',
  },
  medicines_edit: {
    caption: 'Medicinal products catalog: edit',
    description: 'Edit the medicinal products catalog',
  },
  trademarks_view: {
    caption: 'Trade names catalog: view',
    description: 'View the trade names catalog',
  },
  trademarks_edit: {
    caption: 'Trade names catalog: edit',
    description: 'Edit the trade names catalog',
  },
  products_view: {
    caption: 'Product List: view',
    description: 'View Product List registry',
  },
  products_edit: {
    caption: 'Product List: edit',
    description: 'Edit Product List registry',
  },
  products_restrict: {
    caption: 'Product List: Restricted',
    description: 'Restrict access to Product List records',
  },
  products_edit_brand_code: {
    caption: 'Product List: brand code',
    description: 'Edit brand finance code field only',
  },
  submissions_view: {
    caption: 'Submissions: view',
    description: 'View Submissions to MoH registry',
  },
  submissions_edit: {
    caption: 'Submissions: edit',
    description: 'Edit Submissions to MoH registry',
  },
  eaeu_contacts_view: {
    caption: 'EAEU Contacts: view',
    description: 'View EAEU Product Contacts List',
  },
  eaeu_contacts_edit: {
    caption: 'EAEU Contacts: edit',
    description: 'Edit EAEU Product Contacts List',
  },
  sites_view: {
    caption: 'Sites List: view',
    description: 'View Sites List registry',
  },
  sites_edit: {
    caption: 'Sites List: edit',
    description: 'Edit Sites List registry',
  },
  gmp_status_view: {
    caption: 'GMP Status List: view',
    description: 'View GMP Status List',
  },
  gmp_status_edit: {
    caption: 'GMP Status List: edit',
    description: 'Edit GMP Status List',
  },
  gmp_submission_view: {
    caption: 'GMP for submission: view',
    description: 'View GMP for submission',
  },
  gmp_submission_edit: {
    caption: 'GMP for submission: edit',
    description: 'Edit GMP for submission',
  },
  taxes_view: {
    caption: 'Tax: view',
    description: 'View Tax registry',
  },
  taxes_edit: {
    caption: 'Tax: edit',
    description: 'Edit Tax registry',
  },
  taxes_payment_edit: {
    caption: 'Tax: payment orders',
    description: 'Upload payment order and Tax metadata',
  },
  rsd_view: {
    caption: 'RSD: view',
    description: 'View RSD registry',
  },
  rsd_edit: {
    caption: 'RSD: edit',
    description: 'Edit RSD registry',
  },
  documents_view: {
    caption: 'Documents: view',
    description: 'View internal memos',
  },
  documents_edit: {
    caption: 'Documents: create',
    description: 'Create internal memos',
  },
  dossier_view: {
    caption: 'Dossier: view and edit',
    description: 'Full dossier access (without ACL)',
  },
  dossier_acl: {
    caption: 'Dossier: access settings',
    description: 'Configure dossier folder and file permissions',
  },
  dossier_regulatory: {
    caption: 'Dossier: Regulatory',
    description: 'Access to the Regulatory dossier folder',
  },
  dossier_taxes_memos: {
    caption: 'Dossier: Tax and memos',
    description: 'Access to Taxes and internal memo folders',
  },
  dossier_presentations_view: {
    caption: 'Dossier: presentations',
    description: 'View four presentation folders in dossier root (global team)',
  },
  home_view: {
    caption: 'Home page',
    description: 'Access to LTMS home page',
  },
  analytics_view: {
    caption: 'Analytics: view',
    description: 'View Analytics section',
  },
  analytics_edit: {
    caption: 'Analytics: create',
    description: 'Create reports in Analytics section',
  },
  audit_trail_view: {
    caption: 'Audit Trail: view',
    description: 'View Audit Trail section',
  },
  remote_manage: {
    caption: 'ARS: management',
    description: 'Remote management: users, sessions, RDP',
  },
  remote_dossier_projects: {
    caption: 'ARS: projects',
    description: 'Remote access: projects (directories and ACL)',
  },
}

export function getRoleCaption(role, useEnglish = false) {
  const name = role?.name
  if (useEnglish && name && LTMS_ROLE_LABELS_EN[name]?.caption) {
    return LTMS_ROLE_LABELS_EN[name].caption
  }
  return role?.caption || ''
}

export function getRoleDescription(role, useEnglish = false) {
  const name = role?.name
  if (useEnglish && name && LTMS_ROLE_LABELS_EN[name]?.description) {
    return LTMS_ROLE_LABELS_EN[name].description
  }
  return role?.description || ''
}

/** LTMS-роли, не назначаемые через UI (флаг пользователя вместо роли). */
export const HIDDEN_LTMS_ROLE_NAMES = Object.freeze(['globalteam'])

/** LTMS-роли видны на карточке, но add/remove только вне UI ролей (Удалённый доступ). */
export const LOCKED_LTMS_ROLE_NAMES = Object.freeze(['remote_dossier_projects'])

export function isHiddenLtmsRole(role) {
  return role?.service === 'ltms' && HIDDEN_LTMS_ROLE_NAMES.includes(String(role?.name || ''))
}

export function isLockedLtmsRole(role) {
  return role?.service === 'ltms' && LOCKED_LTMS_ROLE_NAMES.includes(String(role?.name || ''))
}

export function withoutHiddenLtmsRoles(roles) {
  return (roles || []).filter(role => !isHiddenLtmsRole(role))
}

export function withoutLockedLtmsRoles(roles) {
  return (roles || []).filter(role => !isLockedLtmsRole(role))
}
